<div id="main" class="internal">
  <div id="edit-slot" class="section edit-slot">
    <div class="content-body">
      <div class="title">
        @if(edit){
        <h1>{{ "edit_slot.title" | translate }}</h1>
        } @else {

        <h1>{{ "edit_slot.add_title" | translate }}</h1>
        }
      </div>
      <div class="content">
        <form [formGroup]="form" class="form" (ngSubmit)="onSubmit()">
          <div class="fieldset">
            <label for="date">{{ "edit_slot.select_date" | translate }}</label>
            <p-datepicker
              formControlName="date"
              [iconDisplay]="'input'"
              [showIcon]="true"
              inputId="date"
              [style]="{ width: '100%' }"
              [firstDayOfWeek]="1"
              selectOtherMonths="true"
            />
          </div>
          <div class="double">
            <div class="fieldset">
              <label for="startTime">{{
                "edit_slot.select_start_time" | translate
              }}</label>
              <p-datepicker
                formControlName="startTime"
                [iconDisplay]="'input'"
                [showIcon]="true"
                [timeOnly]="true"
                inputId="startTime"
                [style]="{ width: '100%' }"
                [stepMinute]="5"
                [firstDayOfWeek]="1"
                selectOtherMonths="true"
              />
            </div>
            <div class="fieldset">
              <label for="endTime">{{
                "edit_slot.select_end_time" | translate
              }}</label>
              <p-datepicker
                formControlName="endTime"
                [iconDisplay]="'input'"
                [showIcon]="true"
                [timeOnly]="true"
                inputId="endTime"
                [style]="{ width: '100%' }"
                [stepMinute]="5"
                [firstDayOfWeek]="1"
                selectOtherMonths="true"
              />
            </div>
          </div>
          <div class="fieldset">
            <label for="category">{{ "edit_slot.category" | translate }}</label>
            <p-select
              formControlName="category"
              [options]="CATEGORIES"
              placeholder="{{ 'edit_slot.select_category' | translate }}"
              inputId="category"
              [style]="{ width: '100%' }"
              [filter]="true"
            />
          </div>
          <div class="table ships">
            <div class="ca-card">
              <p-table
                [value]="tables"
                [(selection)]="selectedTables"
                [paginator]="true"
                [rows]="5"
                [tableStyle]="{ width: '100%' }"
                styleClass="p-datatable-sm p-datatable-striped"
              >
                <ng-template pTemplate="header">
                  <tr>
                    <th style="width: 4rem"><p-tableHeaderCheckbox /></th>
                    <th pSortableColumn="name">
                      {{ "edit_slot.table" | translate }}
                      <p-sortIcon field="name" />
                    </th>
                    <th pSortableColumn="myitalian">
                      {{ "edit_slot.myitalian" | translate }}
                      <p-sortIcon field="myitalian" />
                    </th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-table>
                  <tr>
                    <td>
                      <p-tableCheckbox
                        [value]="table"
                        [disabled]="
                          table.fk_status == 10 ||
                          table.booked ||
                          table.availability == 0
                        "
                      />
                    </td>
                    <td>{{ table.name }}</td>
                    <td>
                      <p-checkbox
                        [(ngModel)]="table.myitalian"
                        [binary]="true"
                        inputId="binary"
                        [ngModelOptions]="{ standalone: true }"
                        [disabled]="table.booked"
                      />
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </div>
          <div class="buttons">
            <button class="costa-button outline" type="button" (click)="Back()">
              {{ "cancel" | translate }}
            </button>
            <button
              class="costa-button"
              type="button"
              [disabled]="!form.valid || !selectedTables.length"
              type="submit"
            >
              {{ "save" | translate }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
